import Service from '@ember/service';
import { assert } from '@ember/debug';

// eslint-disable-next-line ember/no-classic-classes
export default Service.extend({
  // We maintain a count since multiple sources could try to disable scrolling at the same time.
  lockCount: 0,
  scrollCoordinates: null,
  disableWindowScrolling() {
    this.incrementProperty('lockCount');
    if (this.get('lockCount') > 1) {
      return;
    }

    // Store the original scroll position, so we can use it to move the app
    // content up and to the left.
    // NOTE: Using `pageYOffset` instead of `scrollY` since IE11 only has the former
    const scrollY = window.pageYOffset;
    const scrollX = window.pageXOffset;

    // Disable window scrolling while leaving the scroll bar visible
    document.body.classList.add('no-scroll');

    // FIXME(DASHEX-1399): We should fallback correctly when #sq-app-container is
    // not present. As it is now, scrolling is disabled but the content jumps to
    // the top since we're not shifting it here.
    const appElement = document.querySelector('#sq-app-container');
    if (appElement) {
      appElement.style.top = `-${scrollY}px`;
      appElement.style.left = `-${scrollX}px`;
    }
    this.set('scrollCoordinates', {
      scrollX,
      scrollY
    });
  },
  enableWindowScrolling() {
    if (this.get('lockCount') === 0) {
      assert('Scrolling should not be enabled if it was not previously disabled');
      return;
    }
    this.decrementProperty('lockCount');
    if (this.get('lockCount') > 0) {
      return;
    }

    // Restore window scrolling
    document.body.classList.remove('no-scroll');

    // Simulate the original scroll position by moving the app content up and to the left
    const appElement = document.querySelector('#sq-app-container');
    if (appElement) {
      appElement.style.top = 'auto';
      appElement.style.left = 'auto';
    }
    const {
      scrollX,
      scrollY
    } = this.get('scrollCoordinates');
    this.set('scrollCoordinates', null);
    window.scrollTo(scrollX, scrollY);
  }
});